import extend from '../utils/extend';

/* global google */

export default function getInfoWindowClass() {
  return class InfoWindow extends google.maps.OverlayView {
    constructor(map, options = {}) {
      super();

      const _ = this;

      _.options = extend({
        class: '',
      }, options);

      _.iw = document.createElement('div');
      _.iw.classList.add('iw', _.options.class);

      _.hide();
      _.setMap(map);
    }

    onAdd() {
      const _ = this;

      _.getPanes().floatPane.appendChild(_.iw);
    }

    onRemove() {
      const _ = this;

      if (_.iw.parentElement) {
        _.iw.parentElement.removeChild(_.iw);
      }
    }

    draw() {
      const _ = this;

      if (_.position && _.iw.style.visibility !== 'hidden') {
        const iwPosition = _.getProjection().fromLatLngToDivPixel(_.position);

        // Hide the popup when it is far out of view.
        const display = Math.abs(iwPosition.x) < 4000 && Math.abs(iwPosition.y) < 4000 ? 'block' : 'none';

        if (display === 'block') {
          _.iw.style.left = `${iwPosition.x - (_.iw.offsetWidth / 2)}px`;
          _.iw.style.top = `${iwPosition.y - _.iw.offsetHeight - _.marker.icon.anchor.y}px`;
        }
        if (_.iw.style.display !== display) {
          _.iw.style.display = display;
        }
      }
    }

    update(position, content) {
      const _ = this;

      _.position = position;
      if (typeof content === 'string') {
        _.iw.innerHTML = content;
      } else {
        _.iw.innerHTML = '';
        _.iw.appendChild(content);
      }
    }

    show() {
      const _ = this;

      if (_.iw) {
        _.iw.style.visibility = 'visible';
        _.map.panTo(_.position);
        // Center IW instead of marker
        _.map.panBy(0, -(_.iw.offsetHeight / 2));
      }
    }

    hide() {
      const _ = this;

      if (_.iw) _.iw.style.visibility = 'hidden';
    }
  }
}
